import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { Offline } from "react-detect-offline";
import { connect } from "react-redux";
import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
import OfflineIndicator from "components/Offline";
import { NotificationContainer } from "react-notifications";

import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER
} from "constants/ActionTypes";
import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "../util/asyncComponent";
import TopNav from "components/TopNav";

class App extends React.Component {
  render() {
    const {
      match,
      drawerType,
      navigationStyle,
      horizontalNavPosition
    } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "fixed-drawer"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "collapsible-drawer"
      : "mini-drawer";

    // set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }
    return (
      <div className={`app-container ${drawerStyle}`}>
        <Offline>
          <OfflineIndicator />
        </Offline>
        <Sidebar />
        <div
          className={`app-main-container ${
            navigationStyle === HORIZONTAL_NAVIGATION
              ? "app-main-container-horizontal"
              : ""
          }`}
        >
          <div
            className={`app-header ${
              navigationStyle === HORIZONTAL_NAVIGATION
                ? "app-header-horizontal"
                : ""
            }
                            ${
                              navigationStyle === HORIZONTAL_NAVIGATION &&
                              horizontalNavPosition !== INSIDE_THE_HEADER
                                ? " app-header-horizontal-top-below"
                                : ""
                            }`}
          >
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header" />
              )}
            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route
                  exact
                  path={`${match.url}/`}
                  component={asyncComponent(() => import("./routes/Home"))}
                />
                <Route
                  exact
                  path={`${match.url}/listino/:id`}
                  component={asyncComponent(() => import("./routes/Listino"))}
                />
                <Route
                  exact
                  path={`${match.url}/contacts`}
                  component={asyncComponent(() => import("./routes/Contacts"))}
                />
                <Route
                  exact
                  path={`${match.url}/contacts/create`}
                  component={asyncComponent(() =>
                    import("./routes/ContactForm")
                  )}
                />
                <Route
                  exact
                  path={`${match.url}/contacts/:id/edit`}
                  component={asyncComponent(() =>
                    import("./routes/ContactForm")
                  )}
                />
                <Route
                  exact
                  path={`${match.url}/logs`}
                  component={asyncComponent(() => import("./routes/Logs"))}
                />
                <Route
                  exact
                  path={`${match.url}/analytics/basic`}
                  component={asyncComponent(() =>
                    import("./routes/BasicAnalytics")
                  )}
                />
                <Route
                  exact
                  path={`${match.url}/analytics/frequencies`}
                  component={asyncComponent(() =>
                    import("./routes/FrequenciesAnalytics")
                  )}
                />
                <Route
                  exact
                  path={`${match.url}/settings`}
                  component={asyncComponent(() => import("./routes/Settings"))}
                />
                <Route
                  exact
                  path={`${match.url}/settings/smtp`}
                  component={asyncComponent(() =>
                    import("./routes/SMTPSettings")
                  )}
                />
                <Route
                  exact
                  path={`${match.url}/settings/user`}
                  component={asyncComponent(() =>
                    import("./routes/UserSettings")
                  )}
                />
                <Route
                  component={asyncComponent(() =>
                    import("components/Error404")
                  )}
                />
              </Switch>
            </div>
            <Footer />
            <NotificationContainer />
          </main>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  return { drawerType, navigationStyle, horizontalNavPosition };
};
export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./app/index.js